{
  "amazonSalesBanner": {
    "period": "4月17日 23:59まで",
    "title": "期間限定！Amazonで購入すると10%OFF"
  },
  "easeOfUse": {
    "description": "フォトフレームに表示されたQRコードを読み込むだけで自動的にみてねとつながり、すぐに写真や動画がフレームに届きはじめます。\n※ご利用にはWi-Fiが必要です",
    "title": "かんたん設定で\nすぐに思い出が届き始めます",
    "videoTitle": "かんたん設定で すぐに思い出が届き始めます"
  },
  "emotionalClosing": {
    "paragraphs": "映し出されるたびに、愛しさがあふれる\n\n家族をつなぐ、\nかけがえのない日々の記録。\n\nおもいでフォトフレームは\n日常にそっと寄り添い\n家族の思い出を昨日から今日へ\nやさしくつなぎます"
  },
  "faq": {
    "giftAnswer": {
      "description": "アカウントの連携は次の2つのパターンがあります。",
      "intro": "はい、できます。",
      "recipientBody": "受け取る方がみてねのアカウントをお持ちの場合はこの方法がご利用いただけます。フォトフレームを直接お贈りし、受け取る方ご自身がフレームと連携することでお使い頂けます。みてね上の公開範囲がそのまま引き継がれるため、受け取る方がみてねアプリ上で見ることができる写真や動画のみがフォトフレームに表示されます。",
      "recipientTitle": "受け取る方ご本人のアカウントで連携する場合",
      "senderBody": "受け取る方がみてねのアカウントをお持ちでなくてもご利用いただけます。この場合は、贈る方がまずは設定を行い、その後フレームをお贈りください。この場合、贈る方のアカウントで見ることができるすべての写真・動画がフレームに表示される対象となります。※どちらの方法でも、受け取る方のご利用場所にWi-Fi環境が必要です。",
      "senderTitle": "贈る方のアカウントで連携する場合"
    },
    "heading": "よくある質問",
    "items": [
      {
        "answer": "はい。写真や動画を受け取るためにWi-Fi接続が必要です。",
        "question": "Wi-Fiは必要ですか？"
      },
      {
        "answer": "はい。音付きの動画を再生できます。動画の再生にはプレミアムプランへの加入が必要です。音量は設定画面から調整できます。早送りの操作はできません。",
        "question": "動画も見られますか？音は出ますか？"
      },
      {
        "answer": "いいえ、端末の購入だけでご利用いただけます。ただし、みてねプレミアム未加入の場合は、みてねからおすすめの写真11枚のみが月替わりで表示され、動画の表示や11枚以上の写真の表示はできません。写真をご自身で選択することもできません。すでにみてねプレミアムに登録されている場合や、新しく加入された場合は、すべての機能と特典をご利用いただけます。",
        "question": "端末の購入以外にサブスクへの登録は必要ですか？"
      },
      {
        "answer": "はい。プレミアムは「アルバム単位」で適用される機能です。そのため、プレミアムを契約しているアルバムに参加されている方であれば、どなたでもプレミアムの機能をご利用いただけます。たとえば、お客様がプレミアム契約をしているアルバムのオーナーで、そのアルバムにおじいさま・おばあさまが参加されている場合、おじいさま・おばあさまがご自身のアカウントとフォトフレームを連携することで、プレミアムの機能がご利用いただけます。",
        "question": "プレミアムを契約していますが、アルバムに参加している他の家族は追加で契約しなくてもプレミアムの機能が利用できますか？"
      },
      {
        "answer": "無制限に写真を表示するなどのプレミアムの特典はご利用いただけなくなり、みてねからのおすすめ写真11枚のみが月替わりで表示されるようになります。動画の表示や11枚以上の写真の表示、写真をご自身で選択することはできません。",
        "question": "みてねプレミアムを解約したらどうなりますか？"
      },
      {
        "answer": "はい。ネジを別途ご用意のうえ、フレーム背面にある穴を使って壁に掛けることができます。また、付属のスタンドで机や棚の上にも設置できます。※フレームは常に電源に接続して使用する必要があります。",
        "question": "壁掛けはできますか？"
      },
      {
        "answer": "",
        "question": "祖父母など、離れて暮らす家族へプレゼントすることはできますか？",
        "type": "gift"
      },
      {
        "answer": "初期設定時に、それぞれのアルバムから表示する設定にしておくことで、アルバムを切り替えることなく、複数のアルバムの写真や動画をまとめて見ることができます。なお、プレミアムに加入しているアルバムのみプレミアム特典を利用でき、無料のアルバムには表示枚数や機能の制限があります。",
        "question": "みてねで複数のアルバムに参加している場合、どのように表示されますか？"
      },
      {
        "answer": "いいえ、使用できません。フレーム本体に差し込み口はありますが、USBメモリを含む外付け機器はすべて利用できない仕様になっています。",
        "question": "USBメモリ等の外付け機器を使うことはできますか？"
      },
      {
        "answer": "いいえ、バッテリーは内蔵されていないため、ご利用の際は常に電源に接続する必要があります。",
        "question": "コードレスで利用することはできますか？"
      },
      {
        "answer": "はい、表示できます。1枚の縦型写真を中央に配置するモードと、2枚の縦型写真を並べて表示するモードの2つの表示方法からお好きな方を選ぶことができます。",
        "question": "縦型写真は表示できますか？"
      },
      {
        "answer": "いいえ、できません。縦向きに設置しても、写真は横向きのまま表示されます。",
        "question": "フォトフレームを縦に置くことはできますか？"
      },
      {
        "answer": "はい、現在はウォームグレーの1種類のみのご用意となります。",
        "question": "色はウォームグレーの1種類のみですか？"
      }
    ]
  },
  "footer": {
    "manualLink": "WEB版 取扱説明書",
    "manualUrl": "https://mitene.us/digital_photo_frame/manual"
  },
  "hero": {
    "features": [
      {
        "description": "フォトフレームのために、写真を選ぶ必要はありません。「みてね」にアップロードされた写真が、そのまま表示されます。",
        "title": "写真を選ばなくてOK!\nみてねの思い出が自動で表示されます"
      },
      {
        "description": "複数のアルバムに参加している場合は表示したいアルバムを選ぶことで、切り替えの手間なくまとめてスライドショー表示できます。\n※プレミアム契約中のアルバムのみ、すべての写真・動画が表示できます。",
        "title": "複数アルバムの写真や動画も、\n1台でまとめて再生"
      },
      {
        "description": "スライドショーの内容変更やスリープの設定などは、みてねアプリから操作できます。",
        "title": "スマホからも操作できる！"
      }
    ],
    "heading": "おもいでフォトフレームの特徴",
    "postPurchaseFeature": {
      "description": "離れて暮らす家族への贈り物にもぴったり。ご自身のみてねアカウントでセットアップして贈ることも、相手が自分のアカウントでセットアップすることもできます。みてねに追加された新しい写真や動画も、自動で表示されます。\n複数アルバムの写真や動画も、1台でまとめて再生できます。\n※ご利用にはWi-Fiが必要です",
      "title": "プレゼントにもおすすめ"
    },
    "postPurchaseTitle": "みてねの思い出を\nもっと家族のそばに"
  },
  "memories": {
    "body": "みてねをご利用いただいているご家庭で、3歳以上のお子さまがいる場合、平均で7,000件を超える写真や動画が共有されています。\nしかし、そのうち実際に見返されているのは、わずか5%ほどです。たくさんの思い出が、みてねの中でそっと眠ったままになっています。\nこのフォトフレームは、忙しい毎日のなかでもたくさんの思い出を振り返られるように、そんな想いから生まれました。",
    "title": "昔の思い出、\n埋もれてしまってませんか?"
  },
  "postPurchase": {
    "thankYou": "ご購入ありがとうございました！"
  },
  "pricing": {
    "comparison": {
      "freeColumn": "無料",
      "heading": "フォトフレームの機能比較",
      "note": "※写真・動画の枚数が著しく多い一部のユーザーは制限を受けることがあります",
      "premiumColumn": "プレミアム",
      "rows": {
        "filtering": {
          "name": "表示内容の\n絞り込み",
          "premium": "お気に入り\n期間\n公開範囲"
        },
        "mediaCount": {
          "free": "おすすめの写真\n11枚まで",
          "name": "表示できる\n写真・動画の数",
          "premium": "無制限※"
        },
        "multipleAlbums": {
          "name": "複数アルバムの表示"
        },
        "price": {
          "free": "無料",
          "name": "価格 (税込)",
          "premium": "¥590 / 月〜"
        },
        "remoteSettings": {
          "name": "みてねアプリからリモート設定"
        },
        "video": {
          "name": "動画の表示"
        }
      }
    },
    "freeUser": {
      "bodyLead": "本体を購入するだけで、みてねより自動で提案される11枚の写真が毎月表示されます。おすすめの写真は毎月変わります。",
      "bodySub": "プレミアムまたはProプランにご登録いただくと、みてねに保存されたすべての写真と動画が無制限に表示されます。"
    },
    "heading": "価格について",
    "premiumUpsell": {
      "bodyLead": "みてねにある写真・動画をすべて表示できるなど、フォトフレームの機能を無制限でお使いいただけます。",
      "bodySub": "他にもみてねアプリで使える便利で楽しい機能がたくさん！",
      "button": "プレミアムについて詳しくみる",
      "heading": "みてねプレミアムにご登録で\nすべての機能が使えるようになります",
      "priceAmount": "590円",
      "pricePrefix": "",
      "priceSuffix": "(税込)/月~",
      "title": "みてねプレミアム"
    },
    "premiumUser": {
      "badge": "プレミアムプラン契約中のため\nすべての機能をお使いいただけます！",
      "bodyLead": "本体を購入するだけで、すべての写真・動画(※)が無制限に表示されます。",
      "note": "※プレミアムまたはProプランを解約すると、みてねおすすめの11枚の写真が毎月表示されるようになります。"
    },
    "product": {
      "packageContent": "本体/電源ケーブル/サポートスタンド/かんたんセットアップガイド",
      "packageLabel": "パッケージ内容:",
      "price": "16,500円(税込)",
      "title": "本体価格"
    }
  },
  "purchaseButtons": {
    "amazonLabel": "Amazonで購入",
    "amazonSaleText": "今だけ10%OFF",
    "amazonStoreLabel": "Amazonで購入",
    "amazonUrl": "https://www.amazon.co.jp/dp/B0G117GHSW",
    "rakutenLabel": "楽天市場で購入",
    "rakutenUrl": "https://item.rakuten.co.jp/mixiofficial/mdp01-j/",
    "soldOutText": "ご好評につき完売いたしました"
  },
  "purchaseSteps": {
    "amazonSaleText": "\\ 期間限定！Amazonで購入すると10%OFF /",
    "heading": "購入からご利用まで\nかんたんステップ",
    "premiumFeatures": "年間版1秒動画がもらえる\n2分以上の動画アップロード\n広告なしで快適に使える",
    "premiumFeaturesTitle": "プレミアム人気機能",
    "steps": [
      {
        "badge": "STEP 1",
        "description": "おもいでフォトフレームは以下の販売サイトからご購入いただけます。",
        "title": "本体を購入"
      },
      {
        "badge": "STEP 2",
        "description": "本体を電源につなぎ、Wi-Fi設定等をした後にQRコードをスマートフォンで読み込むだけで簡単にみてねと連携できます。",
        "title": "本体が届いたらQRコードを\n読み取るだけで、みてねと連携！"
      },
      {
        "badge": "STEP 3: オプショナル",
        "description": "フォトフレームが無制限に使えるだけでなく、みてねアプリで使える機能が増えます!",
        "title": "プレミアム・Proプランに登録して\n無制限に楽しめる！"
      }
    ]
  },
  "soldOut": {
    "sticky": "ご好評につき完売いたしました！"
  },
  "usageScenes": {
    "heading": "ご利用シーン",
    "scenes": [
      {
        "description": "リビングや寝室など、どんな空間にも自然に溶け込むデザインです。場所を選ばず自由に飾ることができます。家族だんらんの時間に、みてねの思い出を楽しみませんか？",
        "title": "ご自宅のリビングに"
      },
      {
        "description": "離れて暮らす家族への贈り物にもぴったり。\nご自身のみてねアカウントでセットアップして贈ることも、相手が自分のアカウントでセットアップすることもできます。みてねに追加された新しい写真や動画も、自動で表示されます。\n複数アルバムの写真や動画も、1台でまとめて再生できます。\n※ご利用にはWi-Fiが必要です",
        "title": "プレゼントにもおすすめ"
      }
    ]
  },
  "userVoices": {
    "description": "おもいでフォトフレームのある暮らし。\nその心地よさを、\n実際にお使いのみなさまの声とともに\nご紹介します。",
    "eyebrow": "お使いのみなさまの声",
    "heading": "こんな時間が生まれました！",
    "voices": [
      {
        "author": "K.Mさん (8,5,3,0歳のパパ)",
        "body": "4人兄弟のわが家。寝る前になると自然と画面の前に集まり、みんなで写真を見るように。思い出を一緒に眺める時間が、日常を彩ってくれています。",
        "title": "わが家の毎日の楽しみです"
      },
      {
        "author": "R.Tさん (1歳のママ)",
        "body": "これまであまり見る機会がなかった動画が見れて楽しいです。子どもが画面を指さして一生懸命おしゃべりしてくれる姿がとてもかわいいです。",
        "title": "動画が一緒に見れて嬉しい"
      },
      {
        "author": "H.Kさん (3歳のママ)",
        "body": "娘が保育園の写真を一緒に見ながら、「この子はね…」とお友達のことを教えてくれます。とても楽しそうに話してくれて、会話が尽きません。",
        "title": "娘との会話が弾みます"
      },
      {
        "author": "M.Hさん (6,3歳のパパ)",
        "body": "2つのアルバムの写真をまとめて映せるので、姉の子どもとわが家の子どもの写真が並んで表示されることも。今までになかった新しい体験で感動しました。",
        "title": "並んで映る姿に感動しました"
      },
      {
        "author": "A.Nさん (4歳のパパ)",
        "body": "今まで見れていなかった昔の写真がふと表示されて、「こんな瞬間もあったんだ」と再発見。幸せな気持ちになることが増えました。",
        "title": "思いがけない発見があります"
      },
      {
        "author": "J.Oさん (6歳のママ)",
        "body": "いつもはスマホで見ている写真がフレームに表示された時に「大きい〜！綺麗！」と感じました。光沢の感じも良くて満足感があります。",
        "title": "みてねの写真が大きくきれいに"
      }
    ]
  }
}
